// putting this in a .js file so we don't have to convert Intercom scripts to TypeScript
// this file must use ES5 compatible syntax

/* eslint no-var: 0 */
/* eslint semi: 0 */

var scriptsLoaded = false;

// Intercom
function loadIntercom(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',window.intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + window.initProps.config.intercomAppId;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}}

export var loadScripts = function() {
  // load all the 3rd party scripts

  if (!scriptsLoaded) {
    // Intercom script
    // https://docs.intercom.com/configure-intercom-for-your-product-or-site/customize-intercom-to-be-about-your-users/send-custom-user-attributes-to-intercom
    if (window.initProps.enableIntercom && window.initProps.user) {
      var user = window.initProps.user || {};
      var userId = user.id;
      var adminRootUrl = window.location.protocol + '//' + window.location.host + '/admin/manage/users';
      window.intercomSettings = {
        app_id: window.initProps.config.intercomAppId,
        name: user.name,
        email: user.email,
        created_at: Math.round((new Date(user.created_at)).getTime() / 1000),
        user_hash: window.initProps.intercomUserHash,
        user_id: userId,
        user_origin: window.initProps.user.origin,
        user_profile: adminRootUrl + '/' + userId,
        user_apps: adminRootUrl + '/' + userId + '/apps'
      };
      if (location.hostname && location.hostname.toLowerCase().indexOf("install.") === 0) {
        window.intercomSettings.custom_launcher_selector = "#intercomLink";
        window.intercomSettings.hide_default_launcher = true;
      }
      loadIntercom();
    }

    scriptsLoaded = true;
  }
};
